<template>
  <div id="category">
    <div class="banner-image" v-if="featured_image">
      <div :style="`background-image:url(${featured_image})`"></div>
    </div>
    <div class="row">
      <div class="col s12 l10 m10 no-float center-aligned">
        <ul class="crumbs"  v-if="ready">
          <li class="homeCrumb">
            <router-link class="grey-text text-darken-2" to="/"> <i class="material-icons">home</i></router-link>
          </li>
          <li v-if="category">
            <span class="grey-text text-darken-2">{{category.name}}</span>
          </li>
        </ul>
        <section class="flex-row">
          <div class="col s12" v-if="ready">
            <div class="section-title" v-html="category.name"></div>
            <div class="category-description">
              <span v-html="category.description"></span>
            </div>
          </div>
          <div class="col s12 m6 l4" v-for="post in fetched" v-bind:key="post.id">
            <post-card :content="post"/>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>
<script>
import contentService from '@/services/contentService'
import {mapState} from 'vuex'
import PostCard from '@/components/posts/postCard.component'
import {getCategoryPostByType} from '@/services/index'
export default {
  name:'categoryPosts',
  components:{
    PostCard,
  },
  async mounted(){ 
    if(this.$route.query && this.$route.query.type) {
      this.$_getCategoryPostsForType(this.$route.query.type)
      let {data} = await contentService.getCategoryByID(this.$route.query.id)
      this.$store.commit('ADD_CATEGORY', data)
    }
   else this.$_getCategoryPosts()
  },
  data(){
    return {
      fetched:[],
      ready:false,
    }
  },  
  watch:{
    $route:function(nV){
      nV 
      ? this.$_getCategoryPosts()
      : window.console.log('no new content')
    }
  },
  computed:{
    ...mapState({
      posts:state => state.posts,
      all: state => state.all,
      categories: state => state.categories
    }),
    category:{
      get(){
        let record = this.categories.find(category => category.slug === this.$route.params.slug)
        return record ? record : false
      }
    },
    featured_image:{
      get () {
        return this.category && this.category.acf && this.category.acf.featured_image 
          ? this.category.acf.featured_image
          : false
      }
    },
  },
  methods:{
    $_getCategoryPostsForType (type) {
      let id = this.$route.query.id
      getCategoryPostByType(type, id)
      .then(res => {
        this.fetched = res.data
        this.ready = true
      })
    },
    $_getCategoryPosts(){
      const apiFetch = () => {
      contentService.getCategoryPosts(this.$route.query.id)
      .then(res=> {
        let payload = {
          slug:this.$route.params.slug,
          data:res.data
        }
        this.fetched = res.data
     //   this.ready = true
        this.$store.commit('ADD_BULK_POSTS', payload)
      })
      contentService.getCategory(this.$route.params.slug)
      .then(res=>{
         this.$store.commit('ADD_CATEGORY',res.data[0])
         this.ready = true
      })
      .catch(err=>{
        return err
      })
      }
      const storeFectch = () =>{
        this.fetched = this.posts[this.$route.params.slug]
         this.ready = true
      }
      this.posts && this.posts[this.$route.params.slug]
      ? storeFectch()
      : apiFetch()
    }
  }
}
</script>
<style scoped lang="scss">
#category {
min-height: 80vh;
@media screen and (min-width:1024px) {
  padding-left:300px;
}
.category-description {
  font-size: 16px;
  margin-bottom: 12px;
}
.banner-image {
  min-height: 400px;
  background: rgba(0,0,0,0.1);
  position: relative;
  div {
    position: absolute;
    left:0;
    top:0;
    right: 0;
    bottom:0;
    background-size: cover !important;
    background-position:center center ;
  }
}
section {
  &.flex-row {
    display: inline-flex;
    width: 100%;
    flex-wrap: wrap;
    .col {
      float: none;
      margin-left:0;
      margin-right: 0px;
    }
  }
  .section-title {
    font-size: 24px;
    line-height: 1.5;
    margin: 12px 0px 12px 0px;
  }
  .card {
   
    .card-content {
      min-height:120px;
      padding:18px 16px;
    }
    .card-title {
      font-size: 18.5px;
      width: calc(100% - 44px);
      line-height: 1.2;
      font-weight: 500;
      margin-bottom:0px;
      color:rgba(0,0,0,0.7);
    }
  }
}
ul.crumbs {
    margin: 36px 0 0 0px;
    padding: 0px;
    
     li {
      display: inline-flex;
      padding: 0px 5px;
      line-height: 13px;
        &.homeCrumb i {
          vertical-align: middle;
        }
      a {
          &::after {
            content: 'arrow_right';
            font-family: 'Material Icons';
            font-size: 20px;
            vertical-align: middle;
            margin-left: 6px;
          }
      }
    }
  }
  .revised-date {
    margin-left: 39px;
  }
}
</style>